module.exports = __webpack_public_path__ + "img/brand(8).b5c97b2d.png";